import { Component } from 'js-component-framework';

/* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren, no-param-reassign */

// Ensure that closest is supported where polyfills are in use.
if (window.Element && ! Element.prototype.closest) {
  Element.prototype.closest =
  function(element) {
    const matches = (this.document || this.ownerDocument)
      .querySelectorAll(element);
    let index;
    let el = this;
    do { // eslint-disable-line no-cond-assign
      index = matches.length;
      while (0 <= -- index && matches.item(index) !== el) {} // eslint-disable-line no-plusplus, no-empty
    } while ((0 > index) && (el = el.parentElement)); // eslint-disable-line no-const-assign
    return el;
  };
}

/**
 * Component for search page filters.
 */
export default class SearchFacets extends Component {
  /**
   * Submit form on filter change.
   * @param   {object}  event    event object.
   */
  static filterChange(event) {
    // If the date range is custom, don't submit. The user needs to set start and end dates first.
    if (
      'relative_date' === event.target.id
      && 'custom' === event.target.value
    ) {
      SearchFacets.dateChange();
      return;
    }

    // If the user sets the start or end date, don't submit. The user needs to set both first.
    if (
      'start_date' === event.target.id
      || 'end_date' === event.target.id
    ) {
      return;
    }

    // If the date range is set to something other than custom, clear out the values for the custom dates.
    if (
      'relative_date' === event.target.id
      && 'custom' !== event.target.value
    ) {
      document.getElementById('start_date').value = '';
      document.getElementById('end_date').value = '';
    }

    // Submit for when facet changes.
    document.getElementById('search__facet_form').submit();
  }

  /**
   * Submit form on filter change.
   */
  static dateChange() {
    // Show date custom.
    document.querySelector('.date-custom').classList.add('open');
    document.querySelector('.date-custom').setAttribute('aria-hidden', false);
  }

  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
  }

  /**
   * Init
   */
  init() {
    const {
      controls,
    } = this.children;

    if (! controls) {
      return;
    }

    // Reset form.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        document.getElementById('search__facet_form').reset();
      }
    });

    // Ensure that forEach is supported where polyfills are in use.
    if (window.NodeList && ! NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    // Trigger a filter change if any checkboxes are checked or select menus changed.
    controls.forEach(function(item) {
      // Submit form on facet change.
      item.addEventListener(
        'change',
        (event) => SearchFacets.filterChange(event)
      );
    });
  }
}

/* eslint-enable func-names, prefer-arrow-callback, space-before-function-paren, no-param-reassign */
